<template>
<main class="inquiry inquiry-message">
  <h1 class="heading-common is-btn-back"><a class="btn-back" @click="back"></a> {{ $t('inquiry.make_inquiry') }}</h1>

  <transition name="modaltransition" appear>
  <!-- Container -->
  <section class="container">

      <form @submit.prevent="sendMessage">
        <div class="form-group">
          <textarea class="form-control"
              :class="{'is-invalid' : error.message}"
              id="message"
              v-model="form.message"
              @focus="clearErrors"
              rows="10"
              cols="50"
            ></textarea>
          <div class="form-message">{{ $t('inquiry.inquiry_message') }}</div>
        </div>
        <div class="content-bottom">
            <button type="submit" class="button button-primary checkmark" :disabled="loading">
              <span v-show="loading">{{ $t('inquiry.send') }}</span>
              <span v-show="!loading">{{ $t('inquiry.send') }}</span>
            </button>
        </div>
      </form>
  
  </section>
  </transition>
</main>

</template>

<script>
  import {api} from "../../config";
  import { mapActions, mapGetters, mapState } from 'vuex'

  export default {
    data() {
      return {
        loading: false,
        inquiry_id: null,
        inquiry_message: null,
        form: {
          message: ''
        },
        error: {
          message: ''
        }
      }
    },
    
    created() {
      this.inquiry_message = null
      
      if(this.$route.params && this.$route.params['inquiry_message_id']) {
        let currentInquiryMessageId = this.$route.params['inquiry_message_id'];
        
        this.inquiry_message = this.$store.getters.inquirylist.find((item) => {
            return (item.inquiry_message_id == currentInquiryMessageId)
        })
        
        this.form.message = this.inquiry_message.message
        
        if(this.inquiry_message) {
            this.inquiry_id = this.inquiry_message.inquiry_id
        } else {
          if(this.$store.getters.inquirylist.length) {
            this.inquiry_id = this.$store.getters.inquirylist[0].inquiry_id
          }
        }
      } else {
        if(this.$store.getters.inquirylist.length) {
          this.inquiry_id = this.$store.getters.inquirylist[0].inquiry_id
        }
      }
      
      console.log(this.inquiry_message);
    },
    
    methods: {
      sendMessage() {
        const self = this
        
        this.loading = true;
        self.$store.dispatch('showLoading', true)
        
        if(this.form.message && this.form.message.length) {
          let params = this.form
          
          if(this.inquiry_id) {
            params['inquiry_id'] = this.inquiry_id
          }
          if(this.inquiry_message) {
            params['inquiry_message_id'] = this.inquiry_message.inquiry_message_id
          }
          axios.post(api.inquiryStore, params)
            .then((res) => {
              self.loading = false;
              
              self.$store.dispatch('showLoading', false)
              
              self.$router.push({name: 'inquiry'});
            })
            .catch(err => {
              (err.response.data.error)
                ? self.setErrors(err.response.data.error)
                : self.clearErrors();

              self.loading = false;
              self.$store.dispatch('showLoading', false)
            });
        } else {
          this.setErrors();
          this.loading = false;
        }
      },
      setErrors() {
        this.error.message = true
      },
      clearErrors() {
        this.error.message = null;
      },
      back() {
        this.$router.push({name: 'inquiry'})
      }
    }
  }
</script>


<style lang="scss" scoped>
#profile {
  h2 {
  font-weight: bold;
    font-size: 23px;
    line-height: 41px;
    border-bottom: 1px solid #eeeeee;
    padding: 15px;
    color: #686868;
  }

}

@media screen and (min-width: 768px) {
  .main-center {
    width: 100%;
    max-width: 1036px;
    margin: 0 auto;
  }
}

</style>
